"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var actions = require("@caddigital/sok-reducers/lib/actions/bid/basicInformation");
var ZendeskActions = require("@caddigital/sok-reducers/lib/actions/auth/zendesk");
var NavigateConfirmation_1 = require("components/NavigateConfirmation");
var translate_1 = require("utils/translate");
var text_1 = require("utils/text");
var Types = require("types");
require("./style.scss");
var mapStateToProps = function (state) { return ({
    selectedLanguage: (0, translate_1.getLanguage)(),
    zToken: state.auth.zendesk.token,
    basicInformation: state.bid.basicInformation,
    addendumDocuments: state.bid.currentAddendum.documents
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var mapDispatchToProps = function (dispatch) { return ({
    update: function (x, type, publish) {
        if (publish === void 0) { publish = false; }
        if (x.page === 1 && x.currentBid !== null && x.currentAddendum !== null) {
            dispatch(actions.updateRequest(x.currentBriefcase, x.currentBid, x.currentAddendum, type, publish));
        }
        if (x.currentBid && x.basicInformation.values !== null) {
            dispatch(actions.updateRequest(x.currentBriefcase, x.currentBid, x.basicInformation.values, type, publish));
        }
    },
    create: function (briefcase, bid, type, currentBid) {
        var x = {
            briefcase: briefcase,
            body: bid,
            type: type
        };
        if (x.type === 'ADDITIONAL' && currentBid) {
            x.bidId = currentBid.id;
        }
        dispatch(actions.createRequest(x));
    },
    zendeskToken: function () { return dispatch(ZendeskActions.createZendeskTokenRequest()); },
    clearToken: function () { return dispatch(ZendeskActions.resetZendeskToken()); }
}); };
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var zendesk = null;
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('publish', 'setPublish', false), (0, recompose_1.withState)('validationModal', 'setValidationModal', null), (0, recompose_1.withState)('showUpdateConfirmModal', 'setShowUpdateConfirmModal', false), (0, recompose_1.withState)('updateStatus', 'setUpdateStatus', 'STANDBY'), (0, recompose_1.withState)('saveStatus', 'setSaveStatus', 'STANDBY'), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (zendesk && this.props.zToken !== '') {
            var url = "https://sokopro.zendesk.com/access/jwt?jwt=".concat(this.props.zToken, "&return_to=https://sokopro.zendesk.com/");
            zendesk.location.href = url;
            zendesk.focus();
            zendesk = null;
            this.props.clearToken();
        }
        if (prevProps.match.params.folderId !== this.props.match.params.folderId &&
            this.props.match.params.folderId !== undefined) {
            return true;
        }
        if (this.props.basicInformation.publish &&
            this.props.basicInformation.publish !==
                prevProps.basicInformation.publish &&
            this.props.basicInformation.updateStatus === 'FAILED_VALIDATION' &&
            this.props.basicInformation.updateStatus !==
                prevProps.basicInformation.updateStatus) {
            var notifications_1 = [];
            this.props.basicInformation.errors.fold(undefined, function (errors) {
                var e = Object.entries(errors);
                var k = '';
                for (var _i = 0, e_1 = e; _i < e_1.length; _i++) {
                    var _a = e_1[_i], key = _a[0], value = _a[1];
                    k = "".concat((0, translation_1.getLocalization)("bid/basicInformation/notification/".concat(key)), ": ");
                    if (value.length > 0) {
                        value.forEach(function (v) {
                            k += v;
                        });
                    }
                    notifications_1.push(k);
                }
            });
            this.props.setValidationModal(notifications_1);
        }
        // save status inner state
        if (prevProps.basicInformation.saveStatus !==
            this.props.basicInformation.saveStatus) {
            this.props.setSaveStatus(this.props.basicInformation.saveStatus);
        }
        if (prevProps.saveStatus === 'SAVING' &&
            this.props.basicInformation.saveStatus === 'FAILED_VALIDATION') {
            this.props.setSaveStatus('FAILED_VALIDATION');
        }
        if (this.props.saveStatus === 'SAVING' &&
            this.props.basicInformation.saveStatus === 'FAILED_VALIDATION') {
            this.props.setSaveStatus('FAILED_VALIDATION');
        }
        // update status inner state
        if (prevProps.basicInformation.updateStatus !==
            this.props.basicInformation.updateStatus) {
            this.props.setUpdateStatus(this.props.basicInformation.updateStatus);
        }
        if (prevProps.updateStatus === 'UPDATING' &&
            this.props.basicInformation.updateStatus === 'FAILED_VALIDATION') {
            this.props.setUpdateStatus('FAILED_VALIDATION');
        }
        if (this.props.updateStatus === 'UPDATING' &&
            this.props.basicInformation.updateStatus === 'FAILED_VALIDATION') {
            this.props.setUpdateStatus('FAILED_VALIDATION');
        }
    }
}), recompose_1.pure);
var BidButtons = function (props) { return (React.createElement("div", null,
    React.createElement(sok_ui_1.Button, { size: 'large', icon: React.createElement(sok_ui_1.Icon, { className: 'fa-save' }), text: (0, translation_1.getLocalization)("bid/basicInformation/".concat(props.currentBid && props.currentBid.status === 'BID'
            ? 'updateBid'
            : 'createBid')), disabled: props.basicInformation.saveStatus === 'SAVING' ||
            props.basicInformation.updateStatus === 'UPDATING' ||
            (props.currentBid && props.currentBid.status === 'BID'
                ? !props.basicInformation.hasUnsavedChanges
                : false), onClick: function () {
            if (props.currentBriefcase &&
                props.basicInformation &&
                props.basicInformation.values) {
                if (props.mode === 'CREATE') {
                    props.create(props.currentBriefcase, props.basicInformation.values, props.type, props.currentBid);
                    props.setSaveStatus('SAVING');
                }
                else if (props.currentBid &&
                    (props.currentBid.status === 'BID' ||
                        props.currentBid.status === 'ADDENDUMS')) {
                    props.setShowUpdateConfirmModal(true);
                }
                else {
                    props.setUpdateStatus('UPDATING');
                    props.update(props, props.type);
                }
            }
        }, color: 'green' }),
    React.createElement(sok_ui_1.Button, { size: 'large', icon: React.createElement(sok_ui_1.Icon, { className: 'fa-share' }), text: (0, translation_1.getLocalization)('bid/basicInformation/publish'), disabled: props.basicInformation.updateStatus === 'UPDATING' ||
            !props.currentBid ||
            (props.currentBid && props.currentBid.status === 'BID'), onClick: function () { return props.update(props, props.type, true); }, color: 'blue' }),
    React.createElement(sok_ui_1.Button, { color: 'dark-gray', size: 'large', onClick: function () {
            props.history.push("/".concat((0, translate_1.getLanguage)(), "/briefcase/").concat(props.currentBriefcase.id, "/"));
        } },
        React.createElement("div", { className: 'sok-button-text' }, (0, translation_1.getLocalization)('bid/basicInformation/close'))))); };
var LetterButtons = function (props) { return (React.createElement("div", null,
    React.createElement(sok_ui_1.Button, { size: 'large', icon: React.createElement(sok_ui_1.Icon, { className: 'fa-save' }), text: (0, translation_1.getLocalization)("bid/basicInformation/".concat(props.currentAddendum
            ? 'updateAdditionalLetter'
            : 'createAdditionalLetter')), disabled: (props.currentBid &&
            props.currentBid.endAt !== null &&
            props.currentBid.endAt < Date.now()) ||
            props.page === 1 ||
            props.basicInformation.saveStatus === 'SAVING' ||
            props.basicInformation.updateStatus === 'UPDATING' ||
            (props.currentAddendum && props.currentAddendum.status === 'ADDENDUMS'
                ? !props.basicInformation.hasUnsavedChanges
                : false), onClick: function () {
            if (props.currentBriefcase &&
                props.basicInformation &&
                props.basicInformation.values) {
                if (props.mode === 'CREATE') {
                    props.setUpdateStatus('SAVING');
                    props.create(props.currentBriefcase, props.basicInformation.values, props.type, props.currentBid);
                }
                else if (props.currentAddendum &&
                    props.currentAddendum.status === 'ADDENDUMS') {
                    props.setShowUpdateConfirmModal(true);
                }
                else {
                    props.setUpdateStatus('UPDATING');
                    props.update(props, props.type, false);
                }
            }
        }, color: 'green' }),
    React.createElement(sok_ui_1.Button, { size: 'large', icon: React.createElement(sok_ui_1.Icon, { className: 'fa-share' }), text: (0, translation_1.getLocalization)('bid/basicInformation/publishAdditionalLetter'), disabled: props.basicInformation.updateStatus === 'UPDATING' ||
            (props.currentAddendum &&
                props.currentAddendum.status === 'ADDENDUMS') ||
            props.mode === 'CREATE', onClick: function () {
            props.setUpdateStatus('UPDATING');
            props.update(props, props.type, true);
        }, color: 'blue' }),
    React.createElement(react_router_dom_1.Link, { to: "/".concat((0, translate_1.getLanguage)(), "/briefcase/").concat(props.currentBriefcase.id, "/bid/").concat(props.match.params.bid, "/letters"), className: 'sok-button sok-button-color-dark-gray large' },
        React.createElement("div", { className: 'sok-button-text' }, (0, translation_1.getLocalization)('bid/basicInformation/close'))))); };
var NavigationButtons = function (props) { return (React.createElement("div", null,
    React.createElement(sok_ui_1.Button, { size: 'large', disabled: props.page === 0, icon: React.createElement(sok_ui_1.Icon, { className: 'fa-chevron-left' }), text: (0, translation_1.getLocalization)('buttons/previous'), onClick: function () {
            props.history.push("/".concat(props.selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bid/").concat(props.match.params.bid, "/letter/").concat(props.match.params.letterId));
        }, color: 'blue' }),
    React.createElement(sok_ui_1.Button, { size: 'large', className: 'next', disabled: !(props.page === 0 && props.match.params.letterId !== undefined), text: (0, translation_1.getLocalization)('buttons/next'), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-chevron-right' }), onClick: function () {
            if (props.addendumDocuments) {
                props.history.push("".concat(props.match.url, "/files/").concat(props.addendumDocuments.id));
            }
        }, color: 'blue' }))); };
var NavigationMenu = enhance(function (props) {
    var updateModalPrefix = "bid/basincInfo/modal/update".concat((0, text_1.capitalize)(props.type));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'bid-navigation-menu' },
            React.createElement(sok_ui_1.RequestStatusBox, { status: props.saveStatus.replace('_VALIDATION', ''), statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
                React.createElement("span", null, (0, translation_1.getLocalization)('bid/basicInformation/status/saving')),
                React.createElement("span", null, (0, translation_1.getLocalization)('bid/basicInformation/status/saved')),
                React.createElement("span", null, (0, translation_1.getLocalization)("bid/basicInformation/status/".concat(props.saveStatus === 'FAILED_VALIDATION'
                    ? 'validation-error'
                    : 'failed')))),
            React.createElement(sok_ui_1.RequestStatusBox, { status: props.updateStatus.replace('_VALIDATION', ''), statusList: ['STANDBY', 'UPDATING', 'UPDATED', 'FAILED'] },
                React.createElement("span", null, (0, translation_1.getLocalization)('bid/basicInformation/status/saving')),
                React.createElement("span", null, (0, translation_1.getLocalization)('bid/basicInformation/status/saved')),
                React.createElement("span", null, (0, translation_1.getLocalization)("bid/basicInformation/status/".concat(props.updateStatus === 'FAILED_VALIDATION'
                    ? 'validation-error'
                    : 'failed')))),
            React.createElement(sok_ui_1.RequestStatusBox, { status: props.basicInformation.saveOpeningEventStatus.replace('_VALIDATION', ''), statusList: ['STANDBY', 'UPDATING', 'UPDATED', 'FAILED'] },
                React.createElement("span", null, (0, translation_1.getLocalization)('bid/basicInformation/status/saving')),
                React.createElement("span", null, (0, translation_1.getLocalization)('bid/basicInformation/status/saved')),
                React.createElement("span", null, (0, translation_1.getLocalization)("bid/basicInformation/status/".concat(props.updateStatus === 'FAILED_VALIDATION'
                    ? 'validation-error'
                    : 'failed')))),
            React.createElement(NavigateConfirmation_1.default, { display: props.basicInformation.hasUnsavedChanges ||
                    props.basicInformation.hasOpeningEventChanged // ||
                , header: (0, translation_1.getLocalization)('global/confirmation'), firstRow: (0, translation_1.getLocalization)('bid/basicInformation/navigateConfirmation1'), secondRow: (0, translation_1.getLocalization)('bid/basicInformation/navigateConfirmation2'), confirmText: (0, translation_1.getLocalization)('genericWarningConfirmationModal/discardChanges') }),
            props.type === 'ADDITIONAL' && (React.createElement(sok_ui_1.StepBar, { currentStep: props.page, steps: [
                    (0, translation_1.getLocalization)('sokobid/basicInformation/basicInformation'),
                    (0, translation_1.getLocalization)('sokobid/basicInformation/files')
                ], showStepText: true })),
            React.createElement("div", { className: 'tools-container' }, props.type === 'BID' && (React.createElement(sok_ui_1.Button, { size: 'large', className: 'help-button', icon: React.createElement(sok_ui_1.Icon, { className: 'fa-book' }), text: (0, translation_1.getLocalization)('bid/basicInformation/help'), color: 'dark-gray', onClick: function () {
                    zendesk = window.open('about:blank', 'blank');
                    props.zendeskToken();
                } }))),
            React.createElement("div", { className: 'tools-container' },
                props.type === 'BID' ? (React.createElement(BidButtons, __assign({}, props))) : (React.createElement(LetterButtons, __assign({}, props))),
                props.type === 'ADDITIONAL' && React.createElement(NavigationButtons, __assign({}, props)))),
        React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.validationModal !== null, close: function () { return props.setValidationModal(null); }, header: (0, translation_1.getLocalization)('bid/basincInfo/modal/header3/warning'), body: React.createElement(React.Fragment, null,
                React.createElement(ConfirmDialog_1.Exclamation, null),
                React.createElement("div", null,
                    React.createElement("div", { className: 'title please-confirm-text' },
                        React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)("bid/basincInfo/modal/".concat(props.type === 'ADDITIONAL'
                            ? 'addendumValidation'
                            : 'validation', "Errors")))),
                    React.createElement("div", { className: 'text' },
                        React.createElement("p", null, (0, translation_1.getLocalization)('bid/basincInfo/modal/validation/pleaseConfirm')),
                        props.validationModal &&
                            props.validationModal.map(function (x) { return React.createElement("div", null, x); })))), footer: React.createElement(React.Fragment, null,
                React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setValidationModal(null); } })) }),
        React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'update-warning-confirmation-modal', isOpen: props.showUpdateConfirmModal, close: function () { return props.setShowUpdateConfirmModal(false); }, header: (0, translation_1.getLocalization)("".concat(updateModalPrefix, "/header")), body: React.createElement(React.Fragment, null,
                React.createElement(ConfirmDialog_1.Exclamation, null),
                React.createElement("div", null,
                    React.createElement("div", { className: 'title please-confirm-text' },
                        React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)("".concat(updateModalPrefix, "/title")))),
                    React.createElement("div", { className: 'text' },
                        React.createElement("p", null, (0, translation_1.getLocalization)("".concat(updateModalPrefix, "/aboutToUpdate"))),
                        React.createElement("p", null, (0, translation_1.getLocalization)("".concat(updateModalPrefix, "/pleaseConfirm")))))), footer: React.createElement(React.Fragment, null,
                React.createElement(sok_ui_1.Button, { color: 'green', text: (0, translation_1.getLocalization)("".concat(updateModalPrefix, "/update")), onClick: function () {
                        props.update(props, props.type, false);
                        props.setShowUpdateConfirmModal(false);
                        props.setUpdateStatus('UPDATING');
                    } }),
                React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setShowUpdateConfirmModal(false); } })) })));
});
exports.default = NavigationMenu;
